import module from './module.js'
// Components
import './components/component.js'
import './components/agregar/component.js'
import './components/agregar/confirmacion/component.js'
import './components/agregar/seleccionar/component.js'
import './components/lista/component.js'
import './components/lista/item/component.js'
// Routes
import './routes/empresas.js'
import './routes/empresas/agregar.js'
// Services
import './services/empresas.js'
import './services/EmpresasRfcExiste.js'
import './services/Catalogo/RegimenFiscal.js'

export default module.name



// WEBPACK FOOTER //
// ./src/empresas/index.js